import { getCurrentInstance, ref, onUnmounted, unref } from 'vue'
import { onlineManager } from '@tanstack/vue-query'

export function useOnlineStatus() {
  const isOnline = ref(onlineManager.isOnline())
  const unsubscribe = onlineManager.subscribe((online) => {
    isOnline.value = online
  })
  if (getCurrentInstance()) {
    onUnmounted(unsubscribe)
  }
  return { isOnline }
}

// Reconnect refetch predicate: only when the query is enabled AND the tab is visible.
// Prevents background/asleep tabs from stampeding refetches on the 'online' event.
export function refetchEnabledWhenVisible(enableQueryRef) {
  return () => !!unref(enableQueryRef) && document.visibilityState === 'visible'
}
